module.exports = __webpack_public_path__ + "img/shoyu_menu4.0e9e49ab.png";